import i18n from 'i18next';
import Backend from 'i18next-xhr-backend'; // TODO PWA: werkt dit goed met offline caching door de service worker?
import LanguageDetector from 'i18next-browser-languagedetector';
import {reactI18nextModule} from 'react-i18next';
import moment from 'moment';

const i18Opts = {
    debug: (process.env.NODE_ENV === 'development'),
    defaultNS: 'translations',
    fallbackLng: 'en',
    interpolation: {

        escapeValue: false, // Not needed for React; it already handles escaping.
    },
    ns: ['translations'], // Declare the available namespaces (ie., files) per language.
    react: {

        wait: true, // Whether to assert all provided namespaces are loaded before rendering the component.
    }
}

const androidOpts = Object.assign({}, i18Opts, {
    backend: {
        loadPath: 'file:///android_asset/www/locales/{{lng}}/{{ns}}.json'
    }
});

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(reactI18nextModule)
    .init(window.cordova && window.cordova.platformId === 'android' ? androidOpts : i18Opts)
    .on('languageChanged', (lng) => {

        moment.locale(lng.slice(0, 2)); // Set the moment locale as well.
    });

// Load all required moment locales.
// TODO PWA: moment 3.0 plans to have better support for dynamic importing. It should be used to reduce the default bundle size.

require('moment/locale/nl');
require('moment/locale/de');
require('moment/locale/fr');
require('moment/locale/hr');
require('moment/locale/lv');
require('moment/locale/mk');
require('moment/locale/uk');

moment.locale('en'); // Default to English until the i18next language has been loaded.

moment.fn.toJSON = function() { return this.format('YYYY-MM-DDTHH:mm:ss'); };

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js